import { Skeleton, Stack,CircularProgress,Box  } from '@mui/material';

const MyLoading = () => {
  return (
    // <Stack spacing={1} padding={2}>
    //   <Skeleton variant="text" />
    //   <Skeleton variant="circular" width={60} height={60} />
    //   <Skeleton variant="rectangular" width={500} height={40} />
    //   <Skeleton variant="rectangular" width={500} height={40} />
    //   <Skeleton variant="rectangular" width={500} height={40} />
    //   <Skeleton variant="rectangular" width={500} height={118} />
    // </Stack>
    <Box sx={{ display: 'flex' }}>
    <CircularProgress />
  </Box>
  );
};
export default MyLoading;
